import React, { useEffect, useMemo, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { getLessonById } from '../assets/data';
import TextEditor from './TextEditor';
import LessonContainer from './LessonContainer';

export default function EmbeddedLessonView() {
  const { lessonId } = useParams();
  const [searchParams] = useSearchParams();
  const studentId = searchParams.get('studentId');
  const [lesson, setLesson] = useState(null);

  useEffect(() => {
    if (!lessonId) return;
    try {
      const l = getLessonById(String(lessonId));
      setLesson(l ? { ...l, studentId: studentId || l.studentId } : null);
    } catch (_) {
      setLesson(null);
    }
  }, [lessonId, studentId]);

  const { mainBlock, containerBlocks, homeworkBlocks } = useMemo(() => {
    const editorContentsArr = Array.isArray(lesson?.editorContents) ? lesson.editorContents : [];
    const validEditors = editorContentsArr.filter(ec => ec && typeof ec.content === 'string' && ec.content.trim());
    const main = validEditors.find(ec => ec.id === 'main-editor') || null;
    const lessonContainers = Array.isArray(lesson?.containers) ? lesson.containers : [];
    const containerMetaMap = Object.fromEntries(lessonContainers.map(c => [String(c.id), c]));
    const containerOrder = lessonContainers.map(c => String(c.id));
    const containers = validEditors
      .filter(ec => String(ec.id || '').startsWith('container-'))
      .map(ec => {
        const idStr = String(ec.id);
        const cid = idStr.replace('container-', '');
        const orderIndex = containerOrder.indexOf(String(cid));
        const meta = containerMetaMap[cid] || {};
        return { ...ec, _order: orderIndex === -1 ? 9999 : orderIndex, _containerId: cid, _meta: meta };
      })
      .sort((a,b) => a._order - b._order);
    const hw = validEditors
      .filter(ec => String(ec.id || '').startsWith('homework-'))
      .reduce((acc, ec) => {
        const m = String(ec.id).match(/^homework-(.+?)-container-(.+)$/);
        const hwId = m ? m[1] : 'unknown';
        if (!acc[hwId]) acc[hwId] = [];
        acc[hwId].push(ec);
        return acc;
      }, {});
    return { mainBlock: main, containerBlocks: containers, homeworkBlocks: hw };
  }, [lesson]);

  return (
    <div style={{ padding: 16, maxWidth: 900, margin: '0 auto', background: '#ffffff' }}>
      {mainBlock ? (
        <div style={{ marginBottom: 12 }}>
          <TextEditor id={`embed-main`} initialContent={mainBlock.content} lessonMode={'view_only'} />
        </div>
      ) : null}

      {containerBlocks.map((blk, idx) => (
        <LessonContainer
          key={blk.id || `${blk._containerId}-${idx}`}
          id={`embed-container-${blk._containerId || idx}`}
          initialContent={blk.content}
          lessonMode="view_only"
          isStudent
          sectionType={blk._meta.sectionType}
          sectionTitle={blk._meta.sectionTitle}
          sectionColor={blk._meta.sectionColor}
          sectionMinutes={blk._meta.sectionMinutes}
        />
      ))}

      {Object.keys(homeworkBlocks || {}).length > 0 ? (
        <div style={{ marginTop: 12 }}>
          {Object.entries(homeworkBlocks).map(([hwId, arr]) => (
            <div key={hwId} style={{ marginBottom: 12 }}>
              {arr.map((ec, i) => (
                <div key={`${hwId}-${i}`} style={{ marginBottom: 8 }}>
                  <TextEditor id={`embed-hw-${hwId}-${i}`} initialContent={ec.content} lessonMode={'view_only'} />
                </div>
              ))}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}


